import { useCallback, useEffect } from "react";
import { usePrevious } from "./usePrevious";

export const useChanged = (val, fn) => {
  const prevVal = usePrevious(val);
  useEffect(() => {
    if (prevVal !== val) fn(val, prevVal);
  }, [val, prevVal, fn]);
};
